import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import About from '../About/About';
import Home from '../Home/Home';
import Profile from '../Profile/Profile';
import LoginModalFunc from '../LoginModal/LoginModalFunc';
import ToursResultFunc from '../ToursResult/ToursResultFunc';
import HotelDetailsFunc from '../HotelDetails/HotelDetailsFunc';
import OrderDetailsFunc from '../OrderDetails/OrderDetailsFunc';
import CheckoutFunc from '../Checkout/CheckoutFunc';
import AdminPanel from '../AdminPanel/AdminPanel';
import Contacts from '../Contacts/Contacts';
import FAQ from '../FAQ/FAQ';
import VerifyFunc from '../Verify/VerifyFunc';
import TuryIzMinska from '../Landings/TuryIzMinska';
// import Podbor from '../Podbor/Podbor';
import Turkey from '../Landings/Turkey';
import Egypt from '../Landings/Egypt';
import Georgia from '../Landings/Georgia';
import UAE from '../Landings/UAE';
import China from '../Landings/China';
import Qatar from '../Landings/Qatar';
import Oman from '../Landings/Oman';
import Russia from '../Landings/Russia';
import Thailand from '../Landings/Thailand';
import NotFound from '../NotFound/NotFound';
import ContactModal from '../ContactModal/ContactModal';
import HelpModal from '../HelpModal/HelpModal';
import CoockieModal from '../CoockieModal/CoockieModal';
import Hot from '../Hot/Hot';

class RouterComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Router>
        <Header />
        <Routes>
          <Route path="/ap" element={<AdminPanel />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/about" element={<About />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/verify" element={<VerifyFunc />} />
          <Route path="/contacts" element={<Contacts />} />
          <Route path="/search" element={<ToursResultFunc />} />
          <Route path="/hotel" element={<HotelDetailsFunc />} />
          <Route path="/tour" element={<OrderDetailsFunc />} />
          <Route path="/checkout" element={<CheckoutFunc />} />
          <Route path="/hot" element={<Hot />} />
          <Route path="/tury-iz-minska" element={<TuryIzMinska />} />
          {/* <Route path="/podbor-tura" element={<Podbor />} /> */}
          <Route path="/turkey" element={<Turkey />} />
          <Route path="/egypt" element={<Egypt />} />
          <Route path="/georgia" element={<Georgia />} />
          <Route path="/uae" element={<UAE />} />
          <Route path="/china" element={<China />} />
          <Route path="/qatar" element={<Qatar />} />
          <Route path="/oman" element={<Oman />} />
          <Route path="/russia" element={<Russia />} />
          <Route path="/thailand" element={<Thailand />} />
          <Route path="/" element={<Home />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
        <LoginModalFunc />
        <ContactModal />
        <HelpModal />
        <CoockieModal />
      </Router>
    );
  }
}

export default RouterComponent;
